import { render, staticRenderFns } from "./action-required-response.vue?vue&type=template&id=f5c53290&scoped=true&"
import script from "./action-required-response.vue?vue&type=script&lang=ts&"
export * from "./action-required-response.vue?vue&type=script&lang=ts&"
import style0 from "./action-required-response.vue?vue&type=style&index=0&id=f5c53290&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c53290",
  null
  
)

export default component.exports